package ui.app.assign.detail.kindergarten.editor

import androidx.compose.animation.Crossfade
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.staggeredgrid.LazyStaggeredGridScope
import androidx.compose.foundation.lazy.staggeredgrid.StaggeredGridItemSpan
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.ComposableNavNode
import tk.mallumo.utils.DataState
import tools.rememberString
import ui.app.assign.detail.AppDetailArgs
import ui.app.assign.detail.kindergarten.editor.page.*
import ui.widget.*

@Composable
@ComposableNavNode(AppDetailArgs::class)
fun AppKindergartenEditorUI() {
    with(AppKindergartenEditorScope.rememberScope()) {
        when (val state = vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content(state.nnvl)
        }
    }
}

@Composable
fun AppKindergartenEditorScope.Content(nnvl: AppKindergartenEditorScope.Wrapper) {
    val changes = remember {
        mutableStateOf(nnvl.change)
    }
    LaunchedEffect(nnvl.change) {
        changes.value = nnvl.change
    }
    Column(Modifier.fillMaxSize()) {
        Toolbar(
            nav = nav,
            titlePrefix = Res.string.layer_bottom_detail_editor__title.rememberString(),
            titleSuffix = Res.string.layer_bottom_detail_editor__subtitle_edit.rememberString(),
            onUp = { nav.up() },
            actions = listOf(
                ToolbarAction.save(changes) {
                    action(AppKindergartenEditorVM.Action.Save)
                }
            ))

        InlineTabRow(
            selectedTabIndex = vm.tabIndex,
            tabsCount = vm.tabs.size,
            itemMaxWidth = 192.dp
        ) { index ->
            InlineTab(
                index = index,
                selectedTabIndex = vm.tabIndex,
                isClickable = { _, _ -> true },
                label = vm.tabs[index].name
            ) {
                action(AppKindergartenEditorVM.Action.PageExact(index))
            }
        }

        Crossfade(
            targetState = vm.tabIndex,
            modifier = Modifier.fillMaxSize()
        ) { index ->
            when (vm.tabs[index]) {
                AppKindergartenEditorVM.Tab.General00 -> KindergartenPage00General(nnvl)
                AppKindergartenEditorVM.Tab.Devices01 -> KindergartenPage01Devices(nnvl)
                AppKindergartenEditorVM.Tab.Wireframe02 -> KindergartenPage02Wireframe(nnvl)
                AppKindergartenEditorVM.Tab.Pictures03 -> KindergartenPage03Pictures(nnvl)
                AppKindergartenEditorVM.Tab.Pictures04 -> KindergartenPage04Icons(nnvl)
                AppKindergartenEditorVM.Tab.Audio05 -> KindergartenPage05Audio(nnvl)
                AppKindergartenEditorVM.Tab.Summary06 -> KindergartenPage06Summary(nnvl)
            }
        }
    }
}

fun LazyStaggeredGridScope.NextButton(scope: AppKindergartenEditorScope) {
    with(scope) {
        item(span = StaggeredGridItemSpan.FullLine) {
            Box {

                SepButton(
                    modifier = Modifier.align(Alignment.Center),
                    label = Res.string.layer_bottom_detail_editor__act_next
                ) {
                    action(AppKindergartenEditorVM.Action.PageNext)
                }
            }
        }
    }
}

fun LazyStaggeredGridScope.SaveButton(scope: AppKindergartenEditorScope) {
    with(scope) {
        item(span = StaggeredGridItemSpan.FullLine) {
            Box {
                SepButton(
                    modifier = Modifier.align(Alignment.Center),
                    label = Res.string.layer_bottom_detail_editor__act_save
                ) {
                    action(AppKindergartenEditorVM.Action.Save)
                }
            }
        }
    }
}

@Composable
fun AppKindergartenEditorScope.NextAndSkip(modifier: Modifier = Modifier) {
    Column(
        modifier,
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        SepButton(
            modifier = Modifier.align(Alignment.CenterHorizontally),
            label = Res.string.layer_bottom_detail_editor__act_next
        ) {
            action(AppKindergartenEditorVM.Action.PageNext)
        }
        SepButton(
            modifier = Modifier.align(Alignment.CenterHorizontally),
            label = Res.string.layer_bottom_detail_editor__act_skip_to_summary
        ) {
            action(AppKindergartenEditorVM.Action.PageLast)
        }
    }
}

@Composable
private fun SepButton(
    modifier: Modifier = Modifier,
    label: StringResource,
    action: () -> Unit
) {
    Button(
        onClick = action,
        modifier = Modifier.width(384.dp).then(modifier)
    ) {
        Text(
            text = label.rememberString(),
            fontWeight = FontWeight.Bold
        )
    }
}